import {Injectable, makeStateKey} from '@angular/core';
import {Observable, of, tap} from 'rxjs';
import {TemplateSchema} from '../interfaces/template';
import {ApiService} from "./api.service";

// Создаем ключи для TransferState
const TEMPLATE_CACHE_PREFIX = 'template_';

@Injectable({providedIn: 'root'})
export class TemplateService extends ApiService {
    // Кэш в памяти для клиентской навигации
    private memoryCache = new Map<number, TemplateSchema>();

    getTemplate(templateId: number): Observable<TemplateSchema> {
        // 1. Проверяем кэш в памяти (для клиентской навигации)
        const memoryCached = this.memoryCache.get(templateId);
        if (memoryCached) {
            console.log(`✅ [Memory Cache] Template ${templateId} loaded from memory`);
            return of(memoryCached);
        }

        // 2. Проверяем TransferState (для SSR и первой загрузки)
        const stateKey = makeStateKey<TemplateSchema>(`${TEMPLATE_CACHE_PREFIX}${templateId}`);
        const transferCached = this.transferState.get(stateKey, null);

        if (transferCached) {
            console.log(`✅ [TransferState] Template ${templateId} loaded from TransferState`);
            // Сохраняем в memory cache для будущих навигаций
            this.memoryCache.set(templateId, transferCached);
            return of(transferCached);
        }

        // 3. Нет в кэше - делаем запрос
        console.log(`🔄 [API] Loading template ${templateId} from API`);
        const url = `${this.apiHost}/v1/template/view?tag=getTemplate&id=${templateId}`;

        return this.http.get<TemplateSchema>(url).pipe(
            tap(data => {
                // Сохраняем в memory cache
                this.memoryCache.set(templateId, data);
                // Сохраняем в TransferState (для SSR)
                this.transferState.set(stateKey, data);
                console.log(`💾 [Cached] Template ${templateId} saved to cache`);
            })
        );
    }

    // Метод для предзагрузки (опционально)
    prefetchTemplate(templateId: number): void {
        if (!this.memoryCache.has(templateId)) {
            this.getTemplate(templateId).subscribe();
        }
    }

    // Метод для очистки кэша (если нужно)
    clearCache(): void {
        this.memoryCache.clear();
    }
}
